<template>
  <div class="give-record">

    <div class="search-box">
      <!-- 用户手机号 -->
      <div class="item">
        <span>用户手机号</span>
        <div class="item-content">
          <el-input v-model="giveRecordForm.keywords"
                    size="small"
                    clearable
                    @keyup.enter.native="seachEnterFun"
                    placeholder="用户手机号"></el-input>
        </div>
      </div>

      <!-- 赠送时间 -->
      <div class="item">
        <span style="width: 70px;">赠送时间</span>
        <div class="item-content">
          <el-date-picker v-model="giveRecordForm.create_time"
                          size="small"
                          type="daterange"
                          align="right"
                          unlink-panels
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间"
                          @change="getList">
          </el-date-picker>
        </div>
        <el-button type="primary"
                   size="small"
                   style="margin-left:20px"
                   @click="getList">查询</el-button>
        <el-button size="small"
                   @click="restBtn">重置</el-button>
      </div>

    </div>

    <div style="border: solid 1px #c9cbd6;">
      <el-table v-loading="tableLoading"
                :data="giveRecordData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }">
        <el-table-column v-for="item in tableHeader"
                         :key="item.prop"
                         :prop="item.prop"
                         :label="item.label"
                         :width="item.width"
                         :align="item.align"
                         :fixed="item.fixed">
          <template slot-scope="scope">
            <div v-if="item.prop == 'create_time'">
              {{ scope.row[item.prop] | dateFormat }}
            </div>
            <div v-else-if="item.prop == 'notice_type'">
              {{ scope.row[item.prop] | noticeTypeText }}
            </div>
            <div v-else>{{ !scope.row[item.prop] ? '' : scope.row[item.prop] }}</div>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <!-- 分页 -->
    <pagination v-show="totalNum>0"
                :total="totalNum"
                :page.sync="pagination.page"
                :limit.sync="pagination.pageNumber"
                @pagination="getList" />
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import integralmanage from '@/api/integralmanage.js';
import Pagination from '@/components/Pagination/index';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      giveRecordForm: {
        keywords: '',
        create_time: []
      },
      tableHeader: [
        {
          label: '赠送时间',
          prop: 'create_time',
          width: 'auto',
          align: 'center',
          fixed: 'left'
        },
        {
          label: '赠送类型',
          prop: 'give_type',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '通知方式',
          prop: 'notice_type',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '赠送用户手机号',
          prop: 'phone',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '赠送积分',
          prop: 'integral',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '操作人',
          prop: 'admin_name',
          width: 'auto',
          align: 'center',
          fixed: false
        }
      ],
      giveRecordData: []
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    },
    noticeTypeText(val) {
      let valArr = val.split(',').map((item) => Number(item));
      if (valArr.includes(1) && valArr.includes(2)) {
        return '短信、公众号推送';
      }
      if (valArr.includes(1)) {
        return '短信';
      }
      if (valArr.includes(2)) {
        return '公众号推送';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign(this.pagination, this.giveRecordForm);
      params = _.omit(params, ['create_time']);
      let create_time = this.giveRecordForm.create_time;
      params['create_time_start'] = create_time ? create_time[0] : '';
      params['create_time_end'] = create_time ? create_time[1] : '';
      this.tableLoading = true;
      integralmanage.getIntegralGiveLog(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.giveRecordData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },

    restBtn() {
      for (let key in this.giveRecordForm) {
        if (key == 'create_time') {
          this.giveRecordForm[key] = [];
        } else if (key == 'auth_status') {
          this.giveRecordForm[key] = 0;
        } else {
          this.giveRecordForm[key] = '';
        }
      }
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped >
.give-record {
  text-align: left;
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 80px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>